import type {
  Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type { KaminoInterestedPartyDeleteMutation } from '@/graphql/generated/graphql';

const interestedPartyMutations: UpdatesConfig['Mutation'] = {
  kaminoInterestedPartyDelete: (data: KaminoInterestedPartyDeleteMutation, __: Variables, cache: Cache) => {
    if (data.kaminoInterestedPartyDelete) {
      invalidateQuery('memberships', cache);
    }
  },
};
export default interestedPartyMutations;
